import React, { useState } from 'react';

const ConfigurationApi = ({ format, tenant_auth_token }) => {
    const [showApiKey, setShowApiKey] = useState(false);
    const [copiedField, setCopiedField] = useState(null);

    const baseUrl = `${window.location.origin}/api/v1/fordata`;
    const formatToken = format.token;

    const copyToClipboard = (text, field) => {
        navigator.clipboard.writeText(text);
        setCopiedField(field);
        setTimeout(() => setCopiedField(null), 2000);
    };

    const endpoints = [
        {
            method: 'GET',
            name: 'Listar formatos',
            path: '/formats',
            url: `${baseUrl}/formats`,
            description: 'Retorna la lista de formatos disponibles para el tenant.',
            curl: `curl -X GET "${baseUrl}/formats" \\\n  -H "X-Api-Key: ${tenant_auth_token}"`,
        },
        {
            method: 'GET',
            name: 'Ver schema del formato',
            path: `/formats/{token}/schema`,
            url: `${baseUrl}/formats/${formatToken}/schema`,
            description: 'Retorna la estructura (preguntas/campos) del formato.',
            curl: `curl -X GET "${baseUrl}/formats/${formatToken}/schema" \\\n  -H "X-Api-Key: ${tenant_auth_token}"`,
        },
        {
            method: 'GET',
            name: 'Obtener datos (surveys)',
            path: `/formats/{token}/surveys`,
            url: `${baseUrl}/formats/${formatToken}/surveys`,
            description: 'Retorna los registros del formato con paginaci\u00f3n.',
            curl: `curl -X GET "${baseUrl}/formats/${formatToken}/surveys?page=1&per_page=100" \\\n  -H "X-Api-Key: ${tenant_auth_token}"`,
        },
    ];

    return (
        <div className="row p-3">
            <div className="col-md-12">
                <h5 className="ui-index-configurationFormat-subtitle-tab">API ForData</h5>
                <p className="text-muted mt-1" style={{ fontSize: '0.9em' }}>
                    Usa esta informaci&oacute;n para conectar sistemas externos y consultar los datos de este formato.
                </p>

                {/* Credenciales */}
                <div className="card mt-3">
                    <div className="card-header" style={{ backgroundColor: '#f8f9fa' }}>
                        <strong><i className="fas fa-key mr-2"></i>Credenciales</strong>
                    </div>
                    <div className="card-body">
                        {/* API Key */}
                        <div className="mb-3">
                            <label className="mb-1"><strong>API Key</strong></label>
                            <div className="input-group">
                                <input
                                    type={showApiKey ? "text" : "password"}
                                    className="form-control"
                                    value={tenant_auth_token || ""}
                                    readOnly
                                    style={{ fontFamily: 'monospace', fontSize: '0.85em' }}
                                />
                                <div className="input-group-append">
                                    <button
                                        className="btn btn-outline-secondary"
                                        type="button"
                                        onClick={() => setShowApiKey(!showApiKey)}
                                        title={showApiKey ? "Ocultar" : "Mostrar"}
                                    >
                                        <i className={`fas ${showApiKey ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                    </button>
                                    <button
                                        className="btn btn-outline-secondary"
                                        type="button"
                                        onClick={() => copyToClipboard(tenant_auth_token, 'api_key')}
                                        title="Copiar"
                                    >
                                        <i className={`fas ${copiedField === 'api_key' ? 'fa-check' : 'fa-copy'}`}></i>
                                    </button>
                                </div>
                            </div>
                            <small className="text-muted">Se env&iacute;a en el header: <code>X-Api-Key: TU_API_KEY</code></small>
                        </div>

                        {/* Format Token */}
                        <div>
                            <label className="mb-1"><strong>Format Token</strong></label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={formatToken || ""}
                                    readOnly
                                    style={{ fontFamily: 'monospace', fontSize: '0.85em' }}
                                />
                                <div className="input-group-append">
                                    <button
                                        className="btn btn-outline-secondary"
                                        type="button"
                                        onClick={() => copyToClipboard(formatToken, 'format_token')}
                                        title="Copiar"
                                    >
                                        <i className={`fas ${copiedField === 'format_token' ? 'fa-check' : 'fa-copy'}`}></i>
                                    </button>
                                </div>
                            </div>
                            <small className="text-muted">Identificador &uacute;nico de este formato para las peticiones a la API.</small>
                        </div>
                    </div>
                </div>

                {/* Endpoints */}
                <div className="card mt-3">
                    <div className="card-header" style={{ backgroundColor: '#f8f9fa' }}>
                        <strong><i className="fas fa-plug mr-2"></i>Endpoints</strong>
                    </div>
                    <div className="card-body p-0">
                        {endpoints.map((ep, index) => (
                            <div key={index} className={`p-3 ${index < endpoints.length - 1 ? 'border-bottom' : ''}`}>
                                <div className="d-flex align-items-center mb-1">
                                    <span className="badge badge-success mr-2" style={{ fontFamily: 'monospace' }}>{ep.method}</span>
                                    <strong>{ep.name}</strong>
                                </div>
                                <p className="text-muted mb-2" style={{ fontSize: '0.85em' }}>{ep.description}</p>

                                {/* URL */}
                                <div className="mb-2">
                                    <label className="mb-1" style={{ fontSize: '0.8em', fontWeight: 600 }}>URL</label>
                                    <div className="input-group input-group-sm">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={ep.url}
                                            readOnly
                                            style={{ fontFamily: 'monospace', fontSize: '0.8em' }}
                                        />
                                        <div className="input-group-append">
                                            <button
                                                className="btn btn-outline-secondary"
                                                type="button"
                                                onClick={() => copyToClipboard(ep.url, `url_${index}`)}
                                            >
                                                <i className={`fas ${copiedField === `url_${index}` ? 'fa-check' : 'fa-copy'}`}></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* cURL */}
                                <div>
                                    <label className="mb-1" style={{ fontSize: '0.8em', fontWeight: 600 }}>Ejemplo cURL</label>
                                    <div style={{ position: 'relative' }}>
                                        <pre className="p-2 rounded" style={{
                                            backgroundColor: '#2d2d2d',
                                            color: '#f8f8f2',
                                            fontSize: '0.78em',
                                            overflowX: 'auto',
                                            marginBottom: 0,
                                        }}>
                                            {ep.curl}
                                        </pre>
                                        <button
                                            className="btn btn-sm btn-outline-light"
                                            style={{ position: 'absolute', top: 4, right: 4, padding: '2px 6px', fontSize: '0.75em' }}
                                            onClick={() => copyToClipboard(ep.curl, `curl_${index}`)}
                                        >
                                            <i className={`fas ${copiedField === `curl_${index}` ? 'fa-check' : 'fa-copy'}`}></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Par&aacute;metros */}
                <div className="card mt-3 mb-3">
                    <div className="card-header" style={{ backgroundColor: '#f8f9fa' }}>
                        <strong><i className="fas fa-sliders-h mr-2"></i>Par&aacute;metros de consulta</strong>
                    </div>
                    <div className="card-body p-0">
                        <table className="table table-sm mb-0">
                            <thead>
                                <tr>
                                    <th style={{ width: '20%' }}>Par&aacute;metro</th>
                                    <th style={{ width: '15%' }}>Tipo</th>
                                    <th>Descripci&oacute;n</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><code>page</code></td>
                                    <td><span className="badge badge-secondary">Integer</span></td>
                                    <td>N&uacute;mero de p&aacute;gina (por defecto 1).</td>
                                </tr>
                                <tr>
                                    <td><code>per_page</code></td>
                                    <td><span className="badge badge-secondary">Integer</span></td>
                                    <td>Registros por p&aacute;gina (1–1000, por defecto 100).</td>
                                </tr>
                                <tr>
                                    <td><code>updated_after</code></td>
                                    <td><span className="badge badge-secondary">ISO8601</span></td>
                                    <td>Filtro opcional. Retorna solo registros actualizados despu&eacute;s de esta fecha.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfigurationApi;
